import type { ConnectionType } from '@sembo-private/maps';

import type {
  AccommodationType,
  AmenitiesFilter,
  TransportDirection,
} from '@libs/trip-planner-interfaces';

import { trackGoogleAnalyticsEvent } from './trackEvent';
import { GoogleAnalyticsEvent } from './eventsTypes';

export enum TripPlannerViews {
  TripOVerview = 'tripOverview',
  HotelSelection = 'hotelSelection',
  FlightSelection = 'flightSelection',
}

// Note1: keep alphabetical order
// Note2: function name should have the following structure: track + GoogleAnalyticsEvent[Key]

export function trackAccommodationCardEdited(): void {
  trackGoogleAnalyticsEvent(GoogleAnalyticsEvent.AccommodationCardEdited);
}

export function trackAccommodationFiltersAccommodationType(
  accommodationType: AccommodationType,
  isAdded: boolean
): void {
  trackGoogleAnalyticsEvent(
    GoogleAnalyticsEvent.AccommodationFiltersAccommodationType,
    {
      accommodationType,
      isAdded,
    }
  );
}

export function trackAccommodationFiltersStarsRate(star: number): void {
  trackGoogleAnalyticsEvent(
    GoogleAnalyticsEvent.AccommodationFiltersStarsRate,
    {
      star,
    }
  );
}

export function trackAccommodationFiltersAmenitiesFilters(
  filter: AmenitiesFilter,
  isAdded: boolean
): void {
  trackGoogleAnalyticsEvent(
    GoogleAnalyticsEvent.AccommodationFiltersAmenitiesFilters,
    {
      filter,
      isAdded,
    }
  );
}

export function trackActivitiesFilter(): void {
  trackGoogleAnalyticsEvent(GoogleAnalyticsEvent.ActivitiesFilter);
}

export function trackActivitiesBannerForDestination(): void {
  trackGoogleAnalyticsEvent(
    GoogleAnalyticsEvent.ActivitiesBannerForDestination
  );
}

export function trackDestinationChanged(): void {
  trackGoogleAnalyticsEvent(GoogleAnalyticsEvent.DestinationChanged);
}

export function trackDestinationAdded(): void {
  trackGoogleAnalyticsEvent(GoogleAnalyticsEvent.DestinationAdded);
}

export function trackDestinationRemoved(): void {
  trackGoogleAnalyticsEvent(GoogleAnalyticsEvent.DestinationRemoved);
}

export function trackErrorAddingBasket(): void {
  trackGoogleAnalyticsEvent(GoogleAnalyticsEvent.ErrorAddingBasket);
}

export function trackGoToCheckout(): void {
  trackGoogleAnalyticsEvent(GoogleAnalyticsEvent.GoToCheckout);
}

export function trackMonthChanged(): void {
  trackGoogleAnalyticsEvent(GoogleAnalyticsEvent.MonthChanged);
}

export function trackNightsChanged(): void {
  trackGoogleAnalyticsEvent(GoogleAnalyticsEvent.NightsChanged);
}

export function trackPaxEndChanging(): void {
  trackGoogleAnalyticsEvent(GoogleAnalyticsEvent.PaxEndChanging);
}

export function trackPaxStartChanging(): void {
  trackGoogleAnalyticsEvent(GoogleAnalyticsEvent.PaxStartChanging);
}

export function trackNoTransportSelected(): void {
  trackGoogleAnalyticsEvent(GoogleAnalyticsEvent.NoTransportSelected);
}

export function trackTransportSelected(type: ConnectionType): void {
  trackGoogleAnalyticsEvent(GoogleAnalyticsEvent.TransportSelected, { type });
}

export function trackBookableTransportPortChanged(
  airportType: TransportDirection
): void {
  trackGoogleAnalyticsEvent(GoogleAnalyticsEvent.BookableTransportPortChanged, {
    airport: airportType,
  });
}
